import { FC, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { DropdownSelector2, TimeRangePicker } from '../../../ui'
import Graph from '../../../ui/Graph/Graph'
import style from './style.m.less'
import useRequest from '../../../hooks/useRequest'
import useMount from '../../../hooks/useMount'
import { getPlotstatsAllExtension, getPlotstatsGOData } from '../../../OwnerCard/config'
import { useParams } from 'react-router-dom'
import moment, { Moment } from 'moment'

interface IGraphFrame {
    fuelIds?: number[]
    energyTypeLocalized?: string
}

const GraphFrame: FC<IGraphFrame> = ({ fuelIds, energyTypeLocalized }) => {
    const { t } = useTranslation()
    const { id } = useParams<{ id: string }>()
    const { fetch, result } = useRequest(getPlotstatsGOData)
    const { fetch: fetchAll, result: resultAll } = useRequest(getPlotstatsAllExtension)
    const [range, setRange] = useState<[Moment, Moment] | null>()
    const [energyType, setEnergyType] = useState<number>(0)
    const [stats, setStats] = useState([])

    const energyTypeOptions = [
        {
            id: 0,
            value: 0,
            text: energyTypeLocalized ?? 'Возобновляемая электрическая энергия',
            label: energyTypeLocalized ?? 'Возобновляемая электрическая энергия',
        },
        {
            id: 1,
            value: 1,
            text: 'Общий объем производства электрической энергии',
            label: 'Общий объем производства электрической энергии',
        },
    ]

    useEffect(() => {
        setStats(result?.stats)
    }, [result])

    useEffect(() => {
        setStats(resultAll)
    }, [resultAll])

    useMount(() => {
        fetch({
            getParams: {
                generator_id: id,
            },
        })
    })

    const rangeHandler = (r: [Moment, Moment]) => {
        if (!r) {
            setRange(null)
            return
        }
        setRange([moment(r[0]).startOf('month'), moment(r[1]).startOf('month')])
    }

    useEffect(() => {
        const start_period = range && moment(range[0]).startOf('month').format('YYYY-MM-DD')
        const end_period = range && moment(range[1]).startOf('month').format('YYYY-MM-DD')
        if (energyType === 0) {
            fetch({
                getParams: {
                    generator_id: id,
                    ...(range && {
                        start_period: start_period,
                        end_period: end_period,
                    }),
                },
            })
        } else {
            fetchAll({
                getParams: {
                    generator_id: id,
                    ...(range && {
                        start_period: start_period,
                        end_period: end_period,
                    }),
                },
            })
        }
    }, [range, energyType])

    return (
        <div className={style.graphFrameMain}>
            <div className={style.headerRow}>
                <div>
                    <span className={style.headerPrimary}>{t('detailedCard.graphVolume')}</span>
                    <span className={style.headerSecondary}>({t('detailedCard.scale2')})</span>
                </div>
                <div>
                    {!!fuelIds && (
                        <DropdownSelector2
                            customStyle={{ width: '275px', marginRight: '8px' }}
                            options={energyTypeOptions}
                            onChange={(value) => {
                                setEnergyType(value)
                            }}
                            value={energyType}
                        />
                    )}
                    <TimeRangePicker
                        onlyBeforeDateAndToday={moment()}
                        picker="month"
                        value={range}
                        format={'MMMM YY'}
                        onChange={(value) => rangeHandler(value)}
                    />
                </div>
            </div>
            <div className={style.graph}>
                <Graph stats={stats} period={range} />
            </div>
        </div>
    )
}

export default GraphFrame
